import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { properties } from '../../properties';
import PaymentMethodAccordion from "../Http/PaymentMethodAccordion";
import CheckoutPayment from '../Http/CheckoutPayment';

const Checkout = ({ apiUrl }) => {
  const [payments, setPayments] = useState([]);
  const [proceedCheckout, setProceedCheckout] = useState(false);
  const [checkoutParam, setCheckoutParam] = useState({
    appId: "2",
    region: "EMEA-01",
    presentmentCurrency: "EUR",
    addressLine1: "",
    addressLine2: "",
    customerName: "Test Harness",
    countryCode: "",
    city: "",
    state: "",
    zip: "",
    email: "",
    amount: "200",
    intentType: "SAVE_CARD",
    isEmbedded: true,
    isPayPalTestMode: "No",
    payPalFakeNonce: properties.SEL_PAYPAL_FAKE_NONCE,
    locale: properties.SEL_LOCALE,
    declineRateLimit: "",
    captchaRetryAttempt: "3",
    isCaptchaTestMode: "No",
    captchaSiteKey: properties.SEL_CAPTCHA_SITE_KEY,
    captchaTestDescription: properties.SEL_CAPTCHA_TEST_DESCRIPTION,
    phone: "",
    payments: ["Card"]
  });
  var region = [];
  var intentType = [];
  var locale = [];
  var payPal_fake_nonce = [];
  var captcha_sitekey = [];
  var captcha_testDescription = [];
  var canSubmit = true;

  for (let property in properties.REGIONS) {
    region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
  }

  for (let property in properties.INTENTTYPE) {
    intentType.push(<option value={property} key={property}>{properties.INTENTTYPE[property]}</option>);
  }

  for (let property in properties.LOCALE) {
    locale.push(<option value={property} key={property}>{properties.LOCALE[property]}</option>);
  }

  properties.PAYPAL_FAKE_NONCE.forEach((property) => {
    payPal_fake_nonce.push(<option value={property["value"]} key={property["value"]}>{property.value}</option>);
  });

  properties.CAPTCHA_SITE_KEY.forEach((property) => {
    captcha_sitekey.push(<option value={property["value"]} key={property["value"]}>{property.description}</option>);
  });

  properties.CAPTCHA_TEST_DESCRIPTION.forEach((property) => {
    captcha_testDescription.push(<option value={property["value"]} key={property["value"]}>{property.description}</option>);
  });

  function isNotNullCheck(e, field) {
    if (e === "" || !e) {
      document.getElementsByName(field)[0].classList.add("emptied");
      document.getElementsByName(field)[1].classList.add("emptied");
      canSubmit = false;
    }
    else {
      document.getElementsByName(field)[0].classList.remove("emptied");
      document.getElementsByName(field)[1].classList.remove("emptied");
    }
  }

  function changeAppId(e) {
    isNotNullCheck(e.target.value, "WPG_appId");
    setCheckoutParam({ ...checkoutParam, appId: e.target.value });
  }

  function changeRegion(e) {
    isNotNullCheck(e.target.value, "WPG_region");
    setCheckoutParam({ ...checkoutParam, region: e.target.value });
  }

  function changeCurrency(e) {
    isNotNullCheck(e.target.value, "WPG_presentmentCurrency");
    setCheckoutParam({ ...checkoutParam, presentmentCurrency: e.target.value });
  }

  function changeAmount(e) {
    if (checkoutParam.intentType !== "SAVE_CARD") {
      isNotNullCheck(e.target.value, "WPG_amount");
    }
    setCheckoutParam({ ...checkoutParam, amount: e.target.value });
  }

  function changeAddressLine1(e) {
    setCheckoutParam({ ...checkoutParam, addressLine1: e.target.value });
  }

  function changeAddressLine2(e) {
    setCheckoutParam({ ...checkoutParam, addressLine2: e.target.value });
  }

  function changeCustomerName(e) {
    isNotNullCheck(e.target.value, "WPG_customerName");
    setCheckoutParam({ ...checkoutParam, customerName: e.target.value });
  }

  function changePhone(e) {
    setCheckoutParam({ ...checkoutParam, phone: e.target.value });
  }

  function changeCountryCode(e) {
    setCheckoutParam({ ...checkoutParam, countryCode: e.target.value });
  }

  function changeCity(e) {
    setCheckoutParam({ ...checkoutParam, city: e.target.value });
  }

  function changeState(e) {
    setCheckoutParam({ ...checkoutParam, state: e.target.value });
  }

  function changeZip(e) {
    setCheckoutParam({ ...checkoutParam, zip: e.target.value });
  }

  function changeEmail(e) {
    isNotNullCheck(e.target.value, "WPG_email");
    setCheckoutParam({ ...checkoutParam, email: e.target.value });
  }

  function changeIntentType(e) {
    isNotNullCheck(e.target.value, "WPG_intentType");
    if (e.target.value === properties.INTENTTYPE.SAVE_CARD) {
      setCheckoutParam((prevValue) => { prevValue.amount = "" });
    }
    setCheckoutParam({ ...checkoutParam, intentType: e.target.value });
  }

  function changeIsEmbedded(e) {
    isNotNullCheck(e.target.value, "WPG_isEmbedded");
    setCheckoutParam({ ...checkoutParam, isEmbedded: e.target.value });
    if (e.target.value === false || e.target.value === "No") {
      checkoutParam.isPayPalTestMode = false;
      checkoutParam.isCaptchaTestMode = false;
    }
  }

  function changeIsPayPalTestMode(e) {
    setCheckoutParam({ ...checkoutParam, isPayPalTestMode: e.target.value });
  }

  function changeLocale(e) {
    setCheckoutParam({ ...checkoutParam, locale: e.target.value });
  }

  function changePayPalFakeNonce(e) {
    if (checkoutParam.isPayPalTestMode === true || checkoutParam.isPayPalTestMode === "Yes") {
      isNotNullCheck(e.target.value, "WPG_payPal_fake_nonce");
    }
    setCheckoutParam({ ...checkoutParam, payPalFakeNonce: e.target.value });
  }

  function changeCaptchaRetryAttempt(e) {
    setCheckoutParam({ ...checkoutParam, captchaRetryAttempt: e.target.value });
  }

  function changeDeclineRateLimit(e) {
    setCheckoutParam({ ...checkoutParam, declineRateLimit: e.target.value });
  }

  function changeIsCaptchaTestMode(e) {
    setCheckoutParam({ ...checkoutParam, isCaptchaTestMode: e.target.value });
  }

  function changeCaptchaSitekey(e) {
    if (checkoutParam.isCaptchaTestMode === true || checkoutParam.isCaptchaTestMode === "Yes") {
      isNotNullCheck(e.target.value, "WPG_captcha_sitekey");
    }
    setCheckoutParam({ ...checkoutParam, captchaSiteKey: e.target.value });
  }

  function changeCaptchaTestDescription(e) {
    if (checkoutParam.isCaptchaTestMode === true || checkoutParam.isCaptchaTestMode === "Yes") {
      isNotNullCheck(e.target.value, "WPG_captchaTestDescription");
    }
    setCheckoutParam({ ...checkoutParam, captchaTestDescription: e.target.value });
  }

  useEffect(() => {
    $(".page-body").scrollTop(0);
  }, []);

  useEffect(() => {
    if ((checkoutParam.payments != null && checkoutParam.payments.length === 0)) {
      $('div[name="WPG_payments"]').addClass("emptied");
      $('.accordion.form-control').addClass("emptied");
    }
    else {
      $('div[name="WPG_payments"]').removeClass("emptied");
      $('.accordion.form-control').removeClass("emptied");
    }
  }, [checkoutParam]);

  const onChangePaymentMethod = (selectedPayments, e) => {
    setPayments(selectedPayments);
    setCheckoutParam({ ...checkoutParam, payments: (selectedPayments || []) });
  }

  function submitCheckout(e) {
    e.preventDefault();
    isNotNullCheck(checkoutParam.appId, "WPG_appId");
    isNotNullCheck(checkoutParam.region, "WPG_region");
    isNotNullCheck(checkoutParam.presentmentCurrency, "WPG_presentmentCurrency");
    if (checkoutParam.intentType !== "SAVE_CARD") {
      isNotNullCheck(checkoutParam.amount, "WPG_amount");
    }
    isNotNullCheck(checkoutParam.customerName, "WPG_customerName");
    isNotNullCheck(checkoutParam.email, "WPG_email");
    isNotNullCheck(checkoutParam.intentType, "WPG_intentType");
    isNotNullCheck(checkoutParam.isEmbedded, "WPG_isEmbedded");

    if ((checkoutParam.payments && checkoutParam.payments.length === 0) || checkoutParam.payments === null) {
      $('div[name="WPG_payments"]').addClass("emptied");
      $('.accordion.form-control').addClass("emptied");
      canSubmit = false;
    }
    else {
      $('div[name="WPG_payments"]').removeClass("emptied");
      $('.accordion.form-control').removeClass("emptied");
    }
    if (canSubmit) {
      if (checkoutParam.region === "NoR") {
        setCheckoutParam({ ...checkoutParam, region: "" });
      }
      setProceedCheckout(true);
    }
  }

  const handleRetry = (param) => {
    if (param) {
      setProceedCheckout(false);
    }
  }

  var checkoutTemplate = (
    <div>
      {proceedCheckout ? (<CheckoutPayment checkoutParam={checkoutParam} onRetry={handleRetry}></CheckoutPayment>) : (
        <div className="operation-form">
          <h2>Checkout</h2>
          <form className="form-horizontal" id="checkoutForm" onSubmit={submitCheckout} method="POST">
            <div className="form-group">
              <div className="control-label">
                Client Application ID<span className="mandatory-indicator">*</span>
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_appId" value={checkoutParam.appId} onChange={changeAppId} />
                <div className="error-msg" name="WPG_appId">Client Application ID is mandatory</div>
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                Region<span className="mandatory-indicator">*</span>
              </div>
              <div className="col-sm-5">
                <select className="form-control" name="WPG_region" onChange={changeRegion} value={checkoutParam.region}>
                  {region}
                </select>
                <div className="error-msg" name="WPG_region">Region is mandatory</div>
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                ISO Currency Code<span className="mandatory-indicator">*</span>
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_presentmentCurrency" value={checkoutParam.presentmentCurrency} onChange={changeCurrency} />
                <div className="error-msg" name="WPG_presentmentCurrency">ISO Currency Code is mandatory</div>
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                Intent Type<span className="mandatory-indicator">*</span>
              </div>
              <div className="col-sm-5">
                <select className="form-control" name="WPG_intentType" value={checkoutParam.intentType} onChange={changeIntentType}>
                  {intentType}
                </select>
                <div className="error-msg" name="WPG_intentType">Intent Type is mandatory</div>
              </div>
            </div>
            {checkoutParam.intentType !== "SAVE_CARD" && (
              <div className="form-group">
                <div className="control-label">
                  Amount
                    <span className="mandatory-indicator">*</span>
                </div>
                <div className="col-sm-5">
                  <input type="text" className="form-control" name="WPG_amount" value={checkoutParam.amount} onChange={changeAmount} />
                  {checkoutParam.intentType !== "SAVE_CARD" && (
                    <div className="error-msg" name="WPG_amount">Amount is mandatory</div>
                  )}
                </div>
            </div>)}
            <div className="form-group">
              <div className="control-label">
                Email<span className="mandatory-indicator">*</span>
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_email" value={checkoutParam.email} onChange={changeEmail} />
                <div className="error-msg" name="WPG_email">Email is mandatory</div>
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                Address Line 1
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_addressLine1" value={checkoutParam.addressLine1} onChange={changeAddressLine1} />
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                Address Line 2
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_addressLine2" value={checkoutParam.addressLine2} onChange={changeAddressLine2} />
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                Customer Name<span className="mandatory-indicator">*</span>
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_customerName" value={checkoutParam.customerName} onChange={changeCustomerName} />
                <div className="error-msg" name="WPG_customerName">Customer Name is mandatory</div>
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                Phone
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_phone" value={checkoutParam.phone} onChange={changePhone} />
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                ISO Country Code
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_countryCode" value={checkoutParam.countryCode} onChange={changeCountryCode} />
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                City
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_city" value={checkoutParam.city} onChange={changeCity} />
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                State
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_state" value={checkoutParam.state} onChange={changeState} />
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                Postal/Zip Code
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_zip" value={checkoutParam.zip} onChange={changeZip} />
              </div>
            </div>
            <div className="form-group">
              <div className="control-label">
                isEmbedded<span className="mandatory-indicator">*</span>
              </div>
              <div className="col-sm-5">
                <select className="form-control" name="WPG_isEmbedded" value={checkoutParam.isEmbedded} onChange={changeIsEmbedded}>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <div className="error-msg" name="WPG_isEmbedded">isEmbedded is mandatory</div>
              </div>
            </div>
            {(checkoutParam.isEmbedded === "Yes" || checkoutParam.isEmbedded === true) && (
              <div className="form-group">
                <div className="control-label">
                  Locale
                </div>
                <div className="col-sm-5">
                  <select className="form-control" name="WPG_locale" onChange={changeLocale} value={checkoutParam.locale}>
                    {locale}
                  </select>
                </div>
              </div>
            )}
            <div className="form-group">
              <div className="control-label">
                Captcha Retry Attempt Times
              </div>
              <div className="col-sm-5">
                <input type="text" className="form-control" name="WPG_captchaRetryAttempt" value={checkoutParam.captchaRetryAttempt} onChange={changeCaptchaRetryAttempt} />
              </div>
            </div>
            {(checkoutParam.isEmbedded === "Yes" || checkoutParam.isEmbedded === true) && (
              <div className="form-group">
                <div className="control-label">
                  PayPal Test Mode
                </div>
                <div className="col-sm-5">
                  <select className="form-control" name="WPG_isPayPalTestMode" value={checkoutParam.isPayPalTestMode} onChange={changeIsPayPalTestMode}>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
            )}
            {((checkoutParam.isEmbedded === "Yes" || checkoutParam.isEmbedded === true) && (checkoutParam.isPayPalTestMode === "Yes" || checkoutParam.isPayPalTestMode === true)) && (
              <div className="form-group">
                <div className="control-label">
                  PayPal Fake Nonce<span className="mandatory-indicator">*</span>
                </div>
                <div className="col-sm-5">
                  <select className="form-control" name="WPG_payPal_fake_nonce" onChange={changePayPalFakeNonce} value={checkoutParam.payPalFakeNonce}>
                    {payPal_fake_nonce}
                  </select>
                  <div className="error-msg" name="WPG_payPal_fake_nonce">PayPal Fake Nonce is mandatory</div>
                </div>
              </div>
            )}
            {(checkoutParam.isEmbedded === "Yes" || checkoutParam.isEmbedded === true) && (
              <>
                <div className="form-group">
                  <div className="control-label">
                    Credit Card Decline Rate Limit
                  </div>
                  <div className="col-sm-5">
                    <input type="text" className="form-control" name="WPG_declineRateLimit" value={checkoutParam.declineRateLimit} onChange={changeDeclineRateLimit} />
                  </div>
                </div>
                <div className="form-group">
                  <div className="control-label">
                    Credit Card Captcha Test Mode
                  </div>
                  <div className="col-sm-5">
                    <select className="form-control" name="WPG_isCaptchaTestMode" value={checkoutParam.isCaptchaTestMode} onChange={changeIsCaptchaTestMode}>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
              </>
            )}
            {((checkoutParam.isEmbedded === "Yes" || checkoutParam.isEmbedded === true) && (checkoutParam.isCaptchaTestMode === "Yes" || checkoutParam.isCaptchaTestMode === true)) && (
              <>
                <div className="form-group">
                  <div className="control-label">
                    Credit Card Captcha Sitekey<span className="mandatory-indicator">*</span>
                  </div>
                  <div className="col-sm-5">
                    <select className="form-control" name="WPG_captcha_sitekey" onChange={changeCaptchaSitekey} value={checkoutParam.captchaSiteKey}>
                      {captcha_sitekey}
                    </select>
                    <div className="error-msg" name="WPG_captcha_sitekey">Captcha Sitekey is mandatory</div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="control-label">
                    Credit Card Captcha Test Description<span className="mandatory-indicator">*</span>
                  </div>
                  <div className="col-sm-5">
                    <select className="form-control" name="WPG_captchaTestDescription" onChange={changeCaptchaTestDescription} value={checkoutParam.captchaTestDescription}>
                      {captcha_testDescription}
                    </select>
                    <div className="error-msg" name="WPG_captchaTestDescription">Captcha Test Description is mandatory</div>
                  </div>
                </div>
              </>
            )}
            <div className="form-group">
              <div className="control-label">
                Payment Methods<span className="mandatory-indicator">*</span>
              </div>
              <div className="col-sm-5">
                <PaymentMethodAccordion paymentMethodList={properties.paymentMethodList} payments={payments} disabled={false} onChangePaymentMethod={onChangePaymentMethod} inputPaymentsData={checkoutParam['payments'] || []} />
                <div className="error-msg" name="WPG_payments">Payment Method is mandatory</div>
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-5">
                <button type="submit" className="btn btn-primary">Continue</button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
  return checkoutTemplate;
}

export default Checkout;